<template>
  <!-- && item.isShow === 1 && pcList && pcList.length > 0 -->
  <div class="mode4h5-box-container">
    <div
      class="relative new-mode-header"
      :class="titleAlignmentClass"
      v-if="titleAlignment === 'TITLE_ALIGNMENT_CENTER' && (item.topLanguageMap?.title || item.topLanguageMap?.name)"
    >
      <div>
        <div class="title-left">
          <!-- <img
            class="title-icon"
            v-if="$utils.lang_data(lang, item.list[0] && item.list[0], 'langInfoObj')?.icon"
            :src="$utils.returnImgUrl($utils.lang_data(lang, item.list[0], 'langInfoObj')?.icon)"
            alt
          /> -->
          <span class="title">{{ item.topLanguageMap?.title || item.topLanguageMap?.name || "" }}</span>
        </div>
        <!-- 副标题 -->
        <div class="title_sub" v-if="item.topLanguageMap?.subTitle">{{ item.topLanguageMap?.subTitle || "" }}</div>
        <div
          v-if="!skeletonLoading && (showType === 1 || showType === 2)"
          class="mode-all title-center-more"
          @click="handleClick(item)"
          v-exposure="{ eid: `101_0_${curindex}_132` }"
          :data-id="`101_0_${curindex}_132`"
        >
          <span>{{ $t("Datalang.HomePage_TYPE_all") }}</span>
          <i class="el-icon-arrow-right pl5"></i>
        </div>
      </div>
    </div>
    <div v-if="item && !(isLatest && list.length === 0)" class="mode4-box relative">
      <div class="relative mode4-header" v-if="titleAlignment === 'TITLE_ALIGNMENT_LEFT'">
        <el-skeleton :loading="skeletonLoading" animated :throttle="0">
          <template slot="template">
            <el-skeleton-item variant="text" style="width: 150px; height: 24px; margin-left: -35px" />
          </template>
          <template>
            <div style="display: flex; align-items: center">
              <img
                class="title-icon"
                v-if="$utils.lang_data(lang, item.list[0] && item.list[0], 'langInfoObj')?.icon"
                :src="$utils.returnImgUrl($utils.lang_data(lang, item.list[0], 'langInfoObj')?.icon)"
                alt
              />
              <span class="title">
                {{ $utils.lang_data(lang, item.list[0] && item.list[0], "langInfoObj")?.title }}</span
              >
            </div>
          </template>
        </el-skeleton>
        <i
          v-if="showType === 1"
          @click="$refs.slideListRef?.canGoPrev ? $refs.slideListRef.goToPrev() : ''"
          :class="$refs.slideListRef?.canGoPrev ? '' : 'disabled'"
          class="icon-arrow-common el-icon-arrow-left custom"
        ></i>

        <i
          v-if="showType === 1"
          :class="$refs.slideListRef?.canGoNext ? '' : 'disabled'"
          @click="$refs.slideListRef?.canGoNext ? $refs.slideListRef.goToNext() : ''"
          class="icon-arrow-common el-icon-arrow-right custom"
        ></i>
        <!-- {{ total }} -->
        <div
          v-if="!skeletonLoading && (showType === 1 || showType === 2) && titleAlignment === 'TITLE_ALIGNMENT_LEFT'"
          class="mode-all"
          @click="handleClick(item)"
          :style="{ marginRight: $px2rem(showType === 1 ? 85 : 12) }"
          v-exposure="{ eid: `101_0_${curindex}_132` }"
          :data-id="`101_0_${curindex}_132`"
        >
          <span>{{ $t("Datalang.HomePage_TYPE_all") }}</span>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <div class="hot-content" style="overflow: hidden">
        <!-- 显示4个 -->
        <GameSlide2
          ref="slideListRef"
          v-if="showType === 1"
          :list="list"
          :show-count="colNum"
          :peek-width="2"
          :gap="2"
          @load-more="onLoadMoreGame"
        >
          <template #default="{ item }">
            <gameItem :item="item" :skeletonLoading="skeletonLoading" />
          </template>
        </GameSlide2>
        <div class="p-hot-box" v-else :class="[`content_${content_index}`, 'multi-row']">
          <template v-for="(item, i) in list">
            <div
              class="img-box"
              v-if="hidegd(item)"
              :key="'pc_' + i"
              :class="{ 'mr-0': (i + 1) % colNum === 0 }"
              :style="{ width: `${gameThumbWidth}%`, marginRight: '2%' }"
            >
              <gameItem :key="'game_' + i" :item="item" :skeletonLoading="skeletonLoading" />
            </div>
          </template>
          <div v-if="showType === 3 && isMore" class="more-btn-box">
            <div class="more-btn" @click="moreFun">{{ $t("Datalang.HomePage_BTM_loadmore") }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mode4 from "@/lobby_common/mixins_views/homeModule/mode4.js";
// import GameSlide2 from "./GameSlide2.vue";
const GameSlide2 = () => import("./GameSlide2.vue");
export default {
  mixins: [mode4],
  components: {
    GameSlide2,
  },
  props: ["gameShowType"],
  data() {
    return {};
  },
  methods: {
    onLoadMoreGame() {
      this.moreFun();
    },
  },
};
</script>
<style lang="scss" scoped>
.new-mode-header {
  padding: 0px 10px;
}
.title-center-more {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}
.mode4-header {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 10px;
  .title-icon {
    width: 20px;
    height: 20px;
    margin-left: 10px;
  }
  .title {
    font-size: 15px;
    margin-left: 10px;
    font-weight: bold;
    color: var(--font-color-1601);
  }

  .mode-all {
    box-sizing: border-box;
    height: 28px;
    line-height: 28px;
    padding: 0 10px;
    cursor: pointer;
    color: var(--font-color-200);
    background: var(--button-1200);
    box-shadow: var(--boxShadow-1200);
    border-radius: var(--radius-200);
    font-size: 13px;
  }

  .mode-all:hover {
    background: var(--button-1201);
  }
}

// .mode4-box {
//   margin-top: 10px;
//   // background: var(--background-900);
// }

.content {
  position: relative;
  display: flex;
  // background: #f4f5f9 !important;
  line-height: 0;
}

.el-icon-arrow-left.custom {
  width: 30px;
  position: absolute;
  right: 48px;
  cursor: pointer;
  z-index: 1;
  border-radius: 5px;
  -webkit-border-radius: 5px;
}

.el-icon-arrow-right.custom {
  width: 30px;
  position: absolute;
  right: 12px;
  cursor: pointer;
  z-index: 1;
  border-radius: 5px;
  -webkit-border-radius: 5px;
}

.hot-content {
  overflow: hidden;
  @media (max-width: 768px) {
    touch-action: pan-y pinch-zoom;
  }
  .slide-game {
    width: 25%;
  }
}

.p-hot-box {
  position: relative;
  // display: flex;
  padding: 0 12px;

  &.multi-row {
    padding-bottom: 10px;
    flex-wrap: wrap;
  }

  &.one-row {
    display: flex;
  }

  .img-box {
    position: relative;
    display: inline-block;
    width: 30%;
    padding-top: 24px;
    margin-right: 4%;
    cursor: pointer;
    transition: 0.5s;
    flex-shrink: 0;
    @media (max-width: 768px) {
      padding-top: 12px;
    }
    &:last-child {
      margin-right: 0;
    }
    &.mr-0 {
      margin-right: 0 !important;
    }

    .txt {
      text-align: center;
      height: 36px;
      line-height: 36px;
    }

    .tubiao {
      position: absolute;
      right: 0px;
      width: 40px;
      height: 35px;
      top: 0px;
      box-sizing: border-box;
      z-index: 999;
    }
  }
}

.more-btn-box {
  width: 100%;
  padding: 10px 0;
  text-align: center;
  .more-btn {
    // width: 80px;
    display: inline-block;
    padding: 0 15px;
    height: 28px;
    line-height: 28px;
    color: var(--font-color-600);
    background: var(--background-1000);
    margin: 0 auto;
    border-radius: 5px;
    text-align: center;
    font-size: 12px;
    cursor: pointer;
  }
}
</style>
